export const isFileImage = urlImage => {
  return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(urlImage);
};
